import { getBase64 } from './getBase64';

const createApplicationValidFileTypeSignatures = new Map<string, string>([
  ['JVBERi0', 'application/pdf'],
  ['R0lGODdh', 'image/gif'],
  ['R0lGODlh', 'image/gif'],
  ['iVBORw0KGgo', 'image/png'],
  ['/9j/', 'image/jpeg'],
]);

/**
 * The mime type is based on 1. the content-type of the file, and 2. the file extension.
 * This function validates the file based on its Mine Type and file signature
 */
export const validateSupportedMimeTypes = async (file: File): Promise<boolean> => {
  const validMap = createApplicationValidFileTypeSignatures;
  const validFileSignatures = [...validMap.keys()];
  const validFileMimeTypes = new Set(validMap.values());

  try {
    const base64: string = (await getBase64(file)) as string;
    const fileComponents = base64.split(',');
    if (fileComponents.length < 2) {
      return false;
    }
    const fileMimeType = fileComponents[0].split(';')[0].split(':')[1];
    if (!fileMimeType || !validFileMimeTypes.has(fileMimeType)) {
      return false;
    }
    const fileContent = fileComponents[1];
    return validFileSignatures.some(
      signature => fileContent.startsWith(signature) && validMap.get(signature) === fileMimeType,
    );
  } catch (error) {
    console.error('Error reading file:', error);
    return false;
  }
};
